// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__27-Gj","addWidgetButton":"Header_addWidgetButton__3Y0Yi","dashboardTabs":"Header_dashboardTabs__2Y1QP","active":"Header_active__2WBI8"};